// api.js - Vendors Only
// const API_BASE_URL = 'http://localhost:5000/api';
const API_BASE_URL = 'https://landnest.net:7000/api';
const MEDIA_BASE_URL = 'https://landnest.net:81';

const resolveMediaUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${MEDIA_BASE_URL}/${path.replace(/^\//, '')}`;
};

const normalizeVendor = (vendor) => ({
  ...vendor,
  profile: resolveMediaUrl(vendor.profile),
});

export const getVendors = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/vendors/`);
    const data = await response.json();
    console.log('Vendors API response:', data);
    if (data.success && Array.isArray(data.vendors)) {
      return { ...data, vendors: data.vendors.map(normalizeVendor) };
    }
    return data;
  } catch (error) {
    console.error('Error fetching vendors:', error);
    return { success: false, vendors: [] };
  }
};

export const getVendorDetails = async (vendorId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vendors/${vendorId}/`);
    const data = await response.json();
    if (data.success && data.vendor) {
      return { ...data, vendor: normalizeVendor(data.vendor) };
    }
    return data;
  } catch (error) {
    console.error('Error fetching vendor:', error);
    return null;
  }
};

export const getVendorsByCategory = async (category) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vendors/?profession=${category}`);
    const data = await response.json();
    if (data.success && Array.isArray(data.vendors)) {
      return { ...data, vendors: data.vendors.map(normalizeVendor) };
    }
    return data;
  } catch (error) {
    console.error('Error fetching vendors by category:', error);
    return { success: false, vendors: [] };
  }
};

export const getVendorWorkImages = async (vendorId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vendors/${vendorId}/work-images`);
    const data = await response.json();
    // Normalize work image URLs too
    if (data.success && Array.isArray(data.images)) {
      return {
        ...data,
        images: data.images.map((img) => ({
          ...img,
          url: resolveMediaUrl(img.url),
        })),
      };
    }
    return data;
  } catch (error) {
    console.error('Error fetching vendor work images:', error);
    return { success: false, images: [] };
  }
};

// ============ USER APIS ============

export const getUserLocation = async (userId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/users/${userId}/`);
    const userData = await response.json();
    return userData;
  } catch (error) {
    console.error('Error fetching user location:', error);
    return null;
  }
};